import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../public/images/my-photo.png'


const _hoisted_1 = { class: "h-full bg-primaryFive py-32" }
const _hoisted_2 = { class: "flex h-full w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "hidden xl:flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "translate-z-0 w-full h-full",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = { class: "m-auto justify-between w-full max-w-sm" }
const _hoisted_5 = { class: "flex flex-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "me-3 font-bold text-xl" }, "Sign in with", -1)
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 w-full border-t-2 border-accent" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 w-full text-center font-bold" }, " Or ", -1)
const _hoisted_10 = { class: "mt-4 w-full flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "me-4 my-auto",
  for: "emailInput"
}, "Email address", -1)
const _hoisted_12 = { class: "mt-2 w-full flex" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "me-4 my-auto",
  for: "passwordInput"
}, "Password", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#!",
    class: "text-accent font-bold"
  }, "Forgot password?")
], -1)
const _hoisted_15 = { class: "text-center mt-4 pt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "px-4 py-2 accent-button font-bold"
}, " Login ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_google = _resolveComponent("icon-google")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "m-auto",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("a", { href: _ctx.googleAuthLink }, [
              _createVNode(_component_icon_google)
            ], 8, _hoisted_7)
          ]),
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              class: "ms-auto rounded-sm px-2 py-1 text-black focus-visible:outline-accent",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              type: "email",
              id: "emailInput",
              placeholder: "Enter email"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              class: "ms-auto rounded-sm px-2 py-1 text-black focus-visible:outline-accent",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              id: "passwordInput",
              placeholder: "Enter password"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("p", null, [
              _createTextVNode(" Don't have an account? "),
              _createVNode(_component_router_link, {
                to: "/register",
                class: "text-accent font-bold"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Register")
                ]),
                _: 1
              })
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}